import { useTranslation } from 'react-i18next'
import { ActionBar as BaseActionBar } from '../../../../../ActionBar'
import { SubmitButton } from '../../../../../SubmitButton'
import { useForm } from '../../provider/FormProvider'

export const ActionBar = () => {
  const [t] = useTranslation('web_ui')

  const { isSubmitting } = useForm()

  return (
    <BaseActionBar
      rightContent={
        <SubmitButton
          isSubmitting={isSubmitting}
          label={t(
            'edit_employee_personal_information_form.steps.edit_manually.submit_button'
          )}
        />
      }
    />
  )
}
